import React from 'react';
import { useDragLayer } from 'react-dnd';
import type { CSSProperties } from 'react';
import { DragGhost } from '../DragGhost';
import { ghostLayerTransform } from './ghost-position';
import type { DragData } from '../../domain/dnd/types';
import { selectDocument } from '../../domain/selectors';
import { useEditorStore } from '../../domain/store';

const layerStyle: CSSProperties = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 10000,
  left: 0,
  top: 0,
  width: 'auto',
  height: 'auto',
};

export function DragGhostLayer() {
  const document = useEditorStore(selectDocument);

  const { item, isDragging, sourceClientOffset } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    isDragging: monitor.isDragging(),
    sourceClientOffset: monitor.getSourceClientOffset(),
  }));

  if (!isDragging || !item) {
    return null;
  }

  const drag = item as DragData;
  const transform = ghostLayerTransform(sourceClientOffset, drag);

  return (
    <div style={{ ...layerStyle, transform }}>
      <DragGhost drag={drag} document={document} />
    </div>
  );
}
